import { render } from "./Create.vue?vue&type=template&id=b2fa1464&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=b2fa1464&scoped=true&lang=css"

import exportComponent from "/var/www/html/tsk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fa1464"]])

export default __exports__